import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Card,
  CardBody,
  Input,
  Select,
} from "../../../../../../_metronic/_partials/controls";
import { BlockOrg } from "../../../../../RoleChecker";

export function DistributionNormalEditForm({
  currentData,
  setCurrentData,
  onSubmit,
}) {
  return (
    <>
      <Card>
        <CardBody>
          <div className="form-group row">
            <div className="col">
              <label>No Donasi</label>
              <input
                className="form-control"
                name="donation_id"
                placeholder="Nomor Donasi"
                value={currentData.donation_hid}
                onChange={(e) => {
                  const value = e.target.value;
                  setCurrentData((prev) => ({
                    ...prev,
                    donation_hid: value,
                  }));
                }}
              />
            </div>
            <div className="col">
              <label>Atas Nama</label>
              <input
                className="form-control"
                name="name"
                placeholder="Atas Nama"
                value={currentData.name}
                onChange={(e) => {
                  const value = e.target.value;
                  setCurrentData((prev) => ({
                    ...prev,
                    name: value,
                  }));
                }}
              />
            </div>
          </div>
          <div>
            {BlockOrg() && (
              <button
                className="float-right btn btn-primary m-2"
                onClick={onSubmit}
                disabled={currentData.limit <= 0 && true}
              >
                Terapkan
              </button>
            )}
            {BlockOrg() && (
              <button
                className="float-right btn btn-danger m-2"
                onClick={() => {
                  setCurrentData((prev) => ({
                    ...prev,
                    donation_hid: "",
                    name: "",
                  }));
                }}
              >
                Reset
              </button>
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
}
